export default __webpack_public_path__ + "static/media/autorestart.044b561d.svg";